<template>
  <div>
    <content-card :width="width">
      <template #header>
        <div class="subtitle" v-if="sendStatus == 'success' && sendingMethod !== 'wechat'">
          {{ t("send_report.success") }}
          <div>
            {{ receiverInformation }}
          </div>
        </div>
        <div class="subtitle" v-else-if="sendStatus && sendingMethod == 'wechat'">
          {{ t("send_report.success_wechat") }}
        </div>
        <div class="subtitle" v-else>
          {{ t("send_report.failed") }}
        </div>
      </template>
      <template #description>
        <div class="d-flex justify-content-center flex-column align-items-center g-24" v-if="sendStatus == 'success'">
          <div class="d-flex flex-column g-24">
            <div class="d-flex flex-column w-100 g-24 align-items-center">
              <div class="text-center">{{ t("app_promo.download") }}</div>
              <div class="d-flex flex-row g-24 w-100 justify-content-center">
                <div class="d-flex flex-column align-items-center">
                  <img src="../assets/ios-qr-code.png" class="qr-code" alt="" />
                  <div class="fwd-orange qr-name">{{ t("app_promo.ios") }}</div>
                </div>
                <div class="d-flex flex-column align-items-center">
                  <img src="../assets/android-qr-code.png" class="qr-code" alt="" />
                  <div class="fwd-orange qr-name">{{ t("app_promo.android") }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column w-100 g-24 align-items-center">
              <div class="text-center">{{ t("app_promo.follow_wechat") }}</div>
              <div class="d-flex flex-column align-items-center">
                <img src="../assets/wechat-qr-code.png" class="qr-code" alt="" />
                <div class="fwd-orange qr-name wechat-text">{{ t("app_promo.wechat_official_account") }}</div>
              </div>
            </div>
          </div>
          <button class="continue-button d-flex justify-content-center" @click="nextButton">
            <div>{{ t("button.return_to_result") }}</div>
            <div class="position-relative">
              <img class="spinner" src="../assets/time-spinner.svg" alt="" />
              <div class="countdown">
                <div>{{ countdown.toFixed() }}s</div>
              </div>
            </div>
          </button>
        </div>
        <div class="d-flex justify-content-center flex-column align-items-center g-24" v-else>
          <div v-if="sendStatus == 'invalid_phone_number' && sendingMethod == 'whatsapp'" class="text">
            {{ t("send_report.invalid_number") }}
          </div>
          <div v-else-if="sendStatus == 'timeout_error' && sendingMethod == 'whatsapp'" class="text">
            {{ t("send_report.timeout_error") }}
          </div>
          <div v-else-if="sendStatus == 'failed' && sendingMethod == 'email'" class="text">
            {{ t("send_report.invalid_email") }}
          </div>
          <div v-else class="text">
            {{ t("send_report.template_error") }}
          </div>

          <button class="continue-button-clear d-flex justify-content-center" @click="nextButton">
            <div class="fwd-orange">{{ t("button.back") }}</div>
            <div class="position-relative">
              <img class="spinner" src="../assets/time-spinner-orange.svg" alt="" />
              <div class="countdown fwd-orange">
                <div>{{ countdown.toFixed() }}s</div>
              </div>
            </div>
          </button>

          <button class="continue-button-clear justify-content-center" @click="$emit('continue')">
            {{ t("button.return_to_result") }}
          </button>
        </div>
      </template>
    </content-card>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { locale, t } = useI18n();
    return {
      locale,
      t,
    };
  },
  props: {
    receiverInformation: String,
    sendStatus: String,
    sendingMethod: String,
  },
  data() {
    return {
      countdown: 15,
      interval: undefined,
      width: 80,
    };
  },
  emits: ["back", "continue"],
  mounted() {
    const adjustWidth = () => {
      if (window.innerWidth < 768) {
        this.width = 100;
      } else {
        this.width = 80;
      }
    };
    adjustWidth();
    this.$nextTick(() => {
      window.addEventListener("resize", adjustWidth);
    });
    this.interval = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown == 0) {
        this.nextButton();
      }
    }, 1000);
  },
  methods: {
    nextButton() {
      if (this.sendStatus) {
        this.$emit("continue");
      } else {
        this.$emit("back");
      }
      clearInterval(this.interval);
      this.interval = undefined;
    },
  },
};
</script>

<style scoped>
img {
  width: 32px;
  height: 32px;
}
.content {
  font-size: 31px;
  font-weight: 500;
  text-align: center;
}
.continue-button {
  gap: 12px;
}
.continue-button-clear {
  gap: 12px;
}
.countdown {
  position: absolute;
  display: flex;
  top: 0%;
  left: 0%;
  font-size: 14px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.qr-code {
  width: 110px;
  height: 110px;
}
.qr-name {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
}
.start-content {
  max-width: 80% !important;
}
.text {
  text-align: center;
  font-size: 25px;
  font-weight: 450;
}
.wechat-text {
  width: 200px;
}
@media (max-width: 767px) {
  .content {
    font-size: 14px;
  }
  .qr-name {
    font-size: 14px;
  }
  .qr-code {
    width: 80px;
    height: 80px;
  }
  .countdown {
    font-size: 8px;
  }
  img {
    width: 20px;
    height: 20px;
  }
  .continue-button {
    gap: 5px;
    align-items: center;
  }
  .text {
    font-size: 14px;
  }
}
</style>
